export default {
  // 标签页
  imtokenOperationInfo: "imtoken操作信息",
  tokenPocketLoginInfo: "TokenPocket登录信息",
  bitpieCustomTags: "Bitpie自定义标签",

  // 数据统计
  totalData: "共计",
  dataUnit: "条数据",

  // 加载
  loading: "拼命加载中",

  // 表格列
  operationType: "操作类型",
  ipAddress: "IP地址",
  ipLocation: "IP地理位置",
  operationTime: "操作时间",
  loginDevice: "登录设备",
  port: "端口",

  // 空状态
  noData: "暂无数据",

  // 弹窗标题
  imtokenOperationTypeDescription: "imToken钱包的操作类型说明",

  // 按钮
  downloadDataDetails: "下载数据明细",

  // 下载文件名
  downloadFileName: "TokenPocket登录信息",
};
